import { Skeleton, Tooltip } from '@mui/material';
import { Suspense, type FC } from 'react';
import { getSectionInputs } from '../data/sectionInputs';
import { useSuspenseHardwareConfigurationState } from '@/hooks/useHardwareConfigurationState';

interface Props {
  deviceId: string;
  section: keyof ReturnType<typeof getSectionInputs>;
  isMobile: boolean;
}

const Component: FC<Props> = ({ deviceId, section, isMobile }) => {
  const states = useSuspenseHardwareConfigurationState(deviceId);
  const sectionAttributes = states.find((state) => state.section === section);

  if (!sectionAttributes) return null;

  const { color, sectionLabel: label, Icon } = sectionAttributes;

  return (
    <Tooltip title={label}>
      <Icon
        sx={{
          color,
          fontSize: isMobile ? '20px' : '25px',
          marginRight: '5px',
        }}
      />
    </Tooltip>
  );
};

const Fallback: FC<{ isMobile: boolean }> = ({ isMobile }) => {
  return <Skeleton variant="circular" height={isMobile ? 20 : 25} />;
};

const ProgressIcon: FC<Props> = (props) => {
  return (
    <Suspense fallback={<Fallback isMobile={props.isMobile} />}>
      <Component {...props} />
    </Suspense>
  );
};

export default ProgressIcon;
